// Manage customer accounts: list + edit profile details (merged from users table + legacy_documents)
import { useEffect, useState } from "react";
import { apiRequest } from "../services/apiClient";

const EMPTY = { fullName: "", email: "", phone: "", address: "", city: "", postcode: "" };

export default function AdminUsers() {
  const [users, setUsers] = useState(null);
  const [error, setError] = useState("");
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);
  const [search, setSearch] = useState("");

  function load() {
    apiRequest("/admin/users").then(setUsers).catch(err => setError(err.message));
  }

  useEffect(load, []);

  function startEdit(user) {
    setEditingId(user.id);
    setForm({ fullName: user.fullName || "", email: user.email || "", phone: user.phone || "", address: user.address || "", city: user.city || "", postcode: user.postcode || "" });
    setError("");
  }

  async function save(event) {
    event.preventDefault();
    setSaving(true);
    setError("");
    try {
      await apiRequest(`/admin/users/${editingId}`, { method: "PATCH", body: JSON.stringify(form) });
      setEditingId(null);
      load();
    } catch (err) { setError(err.message); }
    finally { setSaving(false); }
  }

  const filtered = users?.filter(u => {
    const q = search.trim().toLowerCase();
    if (!q) return true;
    return [u.fullName, u.email, u.phone].some(field => (field || "").toLowerCase().includes(q));
  });

  return <div>
    <h2 style={{ color: "#fff", margin: "0 0 8px" }}>Customer Users</h2>
    <p style={{ color: "rgba(255,255,255,0.45)", fontSize: 13, marginBottom: 16 }}>All registered customer accounts. Details are merged from the legacy migrated profiles where available.</p>
    <input placeholder="Search by name, email or phone..." value={search} onChange={event => setSearch(event.target.value)}
      style={{ ...inputStyle, marginBottom: 16, width: 320 }} />
    {error && <p style={{ color: "#f87171", fontSize: 13 }}>{error}</p>}
    {!users && <p style={{ color: "rgba(255,255,255,0.45)", fontSize: 13 }}>Loading...</p>}
    {users && <div className="adm-card">
      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
        <thead>
          <tr style={{ color: "rgba(255,255,255,0.45)", textAlign: "left" }}>
            <th style={{ padding: "10px 12px" }}>Name</th>
            <th style={{ padding: "10px 12px" }}>Email</th>
            <th style={{ padding: "10px 12px" }}>Phone</th>
            <th style={{ padding: "10px 12px" }}>Address</th>
            <th style={{ padding: "10px 12px" }}>Joined</th>
            <th style={{ padding: "10px 12px" }}></th>
          </tr>
        </thead>
        <tbody>
          {filtered.map(u => <tr key={u.id} style={{ borderTop: "1px solid rgba(255,255,255,0.08)", color: "#fff" }}>
            <td style={{ padding: "10px 12px" }}>{u.fullName || "-"}</td>
            <td style={{ padding: "10px 12px" }}>{u.email || "-"}</td>
            <td style={{ padding: "10px 12px" }}>{u.phone || "-"}</td>
            <td style={{ padding: "10px 12px" }}>{[u.address, u.city, u.postcode].filter(Boolean).join(", ") || "-"}</td>
            <td style={{ padding: "10px 12px" }}>{u.createdAt ? new Date(u.createdAt).toLocaleDateString() : "-"}</td>
            <td style={{ padding: "10px 12px" }}><button type="button" className="adm-btn" onClick={() => startEdit(u)}>Edit</button></td>
          </tr>)}
          {filtered.length === 0 && <tr><td colSpan={6} style={{ padding: 20, color: "rgba(255,255,255,0.4)" }}>No users found.</td></tr>}
        </tbody>
      </table>
    </div>}

    {editingId && <div style={overlayStyle} onClick={event => { if (event.target === event.currentTarget) setEditingId(null); }}>
      <form onSubmit={save} className="adm-card" style={{ width: 460, padding: 24, display: "grid", gap: 14 }}>
        <span className="adm-card-title">Edit user</span>
        <Field label="Full name" value={form.fullName} onChange={v => setForm(prev => ({ ...prev, fullName: v }))} />
        <Field label="Email" type="email" value={form.email} onChange={v => setForm(prev => ({ ...prev, email: v }))} />
        <Field label="Phone" value={form.phone} onChange={v => setForm(prev => ({ ...prev, phone: v }))} />
        <Field label="Address" value={form.address} onChange={v => setForm(prev => ({ ...prev, address: v }))} />
        <Field label="City" value={form.city} onChange={v => setForm(prev => ({ ...prev, city: v }))} />
        <Field label="Postcode" value={form.postcode} onChange={v => setForm(prev => ({ ...prev, postcode: v }))} />
        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
          <button type="button" className="adm-btn" onClick={() => setEditingId(null)}>Cancel</button>
          <button className="adm-btn adm-btn-primary" disabled={saving}>{saving ? "Saving..." : "Save"}</button>
        </div>
      </form>
    </div>}
  </div>;
}

function Field({ label, value, onChange, type = "text" }) {
  return <label style={labelStyle}><span>{label}</span><input type={type} value={value} onChange={event => onChange(event.target.value)} required style={inputStyle} /></label>;
}

const labelStyle = { display: "flex", flexDirection: "column", gap: 7, color: "rgba(255,255,255,0.65)", fontSize: 12, fontWeight: 600 };
const inputStyle = { background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.14)", borderRadius: 6, padding: "10px 12px", color: "#fff", fontFamily: "inherit", fontSize: 14 };
const overlayStyle = { position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 };
